export const HOME = "/";
export const ADMIN = "admin";

// JobApply24's application backend has been retired. Visitors are directed to
// Flitz.ai's CV Studio, the successor feature.
export const FLITZ_URL = "https://flitz.ai/register";
